// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useUniqueId } from '@tectonics/hooks';
import { useUserInputAsCheckbox } from '@tectonics/prs/user-input-values';
import { useCurrentAllFeatures } from '@tectonics/prs/payment-spec';
import { hasFeature } from '@tectonics/prs/feature';
import { CheckboxField } from '../../../../atoms';

export function KenyanTermsForInternationalTransfer(): Node {
  const [acceptTerms, setAcceptTerms] = useUserInputAsCheckbox('acceptTerms');
  const inputId = useUniqueId();
  const currentAllFeatures = useCurrentAllFeatures();

  if (!hasFeature(currentAllFeatures, 'field_kenyan_accept_terms_for_international_transfer')) {
    return null;
  }

  return (
    <Container>
      <Paragraph>
        By proceding you acknowledge our{'\u00A0'}
        <Link href="https://business.ebanx.com/en/legal/customers/africa/general-terms" target="_blank" rel="noopener noreferrer">
        Terms of Service
        </Link>
        {'\u00A0'}and{'\u00A0'}
        <Link href="https://www.ebanx.com/en/legal/customers/africa/privacy-policy-kenya/" target="_blank" rel="noopener noreferrer">
        Privacy Notice.
        </Link>
      </Paragraph>

      <Content>
        <CheckboxField
          id={inputId}
          checked={acceptTerms || false}
          onChange={setAcceptTerms}
          dataTestId="accept-terms-international-transfer"
        />
        <AcceptCheckboxLabel htmlFor={inputId} />
      </Content>
    </Container>
  );
}

function AcceptCheckboxLabel(props): Node {
  return (
    <AcceptTermsLabel {...props}>
      I agree with international transfer of personal data to process this payment.
    </AcceptTermsLabel>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f1f5fb;
  padding: 16px 16px 16px 8px;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  padding-left: 8px;
`;

const AcceptTermsLabel = styled.label`
  font-size: .85em;
  color: ${props => props.theme.colors.new_primary[800]};
`;

const Paragraph = styled.p`
  font-size: .85em;
  color: #333f48;
  margin-left: 8px;
`;

const Link = styled.a`
  color: ${props => props.theme.colors.new_primary[600]};
  font-weight: bold;
  text-decoration: none;
`;
